import axios, {AxiosResponse} from 'axios'
import {EvidenceQueryResponse} from '../../../models/IEvidence'
import {SatwilQueryResponse} from './_model'

const API_URL = process.env.REACT_APP_BASE_API_URL
const URL = `${API_URL}/satwil`

const getSatwil = (query: string): Promise<SatwilQueryResponse> => {
  return axios.get(`${URL}/select?${query}`).then((d: AxiosResponse<SatwilQueryResponse>) => d.data)
}

export {getSatwil}
